import { Navigate } from "react-router";
import { useGetAccountingUserQuery } from "../../../apis/AccountingUser.api";
import { PrimaryAccountingUser, AccountingUser } from "../../../types/models/AccountingUser";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const AccountingUserScoped = () => {
    const {
        data,
    } = useGetAccountingUserQuery(PrimaryAccountingUser.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/accounting-users/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default AccountingUserScoped;
